import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { SelectItem } from '@openng/optimus-ui/api';
import { ButtonDirective } from '@openng/optimus-ui/button';
import {
  DynamicDialogConfig,
  DynamicDialogRef,
} from '@openng/optimus-ui/dynamicdialog';
import { Select } from '@openng/optimus-ui/select';

export interface HistoryVersionDialogData {
  versions: SelectItem[];
}

/**
 * "View Historical Record" version picker. Open with DialogService; the dialog
 * closes with the chosen version number, or undefined when dismissed.
 */
@Component({
  selector: 'app-history-version-dialog',
  templateUrl: './history-version-dialog.component.html',
  styleUrls: ['./history-version-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, Select, ButtonDirective, TranslatePipe],
})
export class HistoryVersionDialogComponent {
  private readonly ref = inject(DynamicDialogRef);
  private readonly config = inject(
    DynamicDialogConfig<HistoryVersionDialogData>
  );

  readonly versions: SelectItem[] = this.config.data?.versions ?? [];
  readonly selectedVersion = signal<number | null>(null);

  openVersion(): void {
    const version = this.selectedVersion();
    if (version !== null) {
      this.ref.close(version);
    }
  }
}
